import React, {useEffect, useState} from 'react'
import {Row} from 'react-bootstrap';
import Loading from '../../component/Loading/Loading';

import ByondGrid2 from '../../customGrid/CustomGrid';

var ONE_DAY = 1000 * 60 * 60 * 24;

const TODAY_TITLE = 'Hoje';

const getLastDay = (days) => {
  if (days && days.length === 0) {
    return 0;
  }

  days.sort(function (a, b) {
    return new Date(b.stockDate) - new Date(a.stockDate)
  });

  console.log('asd asd asqui', days);
  return days[0];
}

const DEFAULT_COLUMNS = [
  {
    Header: <div className="header">Referência</div>,
    width: 150,
    Cell: row => <div className="reference">{row.original.productType.reference}</div>
  },
  {
    Header: <div className="header">Valor Nível</div>,
    Cell: row => {
      const day = getLastDay(row.original.days);
      return <div className="stock">{day ? day.quantitySecure : 0}</div>
    }
  }
]

const format2Digits = (value) => {
  if (value >= 10) {
    return value
  }
  return '0' + value;
}

const getPercentAndQuantity = (quantity, percent) => {
  if (Math.sign(quantity) === -1 || quantity === 0) {
    return `${quantity} | ${percent}%`
  }
  return `+${quantity} | ${percent}%`
}

const TODAY = new Date();

const isToday = (data) => {
  return data.getDate() === TODAY.getDate()
      && data.getMonth() === TODAY.getMonth()
      && data.getFullYear() === TODAY.getFullYear();
}

const getTitle = (date) => {
  const data = new Date(date);
  let title = format2Digits(data.getDate()) + '/' + (format2Digits((data.getMonth() + 1)));

  if (isToday(data)) {
    title = TODAY_TITLE;
  }

  return title;
}

const getRowItem = (item) => {

  if (!item || item && isNaN(item.percent)) {
    return <div className="stock-item">Sem dados</div>;
  }

  const {percent, total, date} = item;

  if (percent <= 65) {
    return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#F7685B'}}>{getPercentAndQuantity(total, percent)}</div>
  }
  if (percent <= 80 && percent > 65) {
    return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#FFB946'}}>{getPercentAndQuantity(total, percent)}</div>
  }
  if (percent <= 90 && percent > 80) {
    return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#F2E14C'}}>{getPercentAndQuantity(total, percent)}</div>
  }
  if (percent > 90 && percent <= 120) {
    return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#2ED47A'}}>{getPercentAndQuantity(total, percent)}</div>
  }
  if (percent >= 120 && percent < 130) {
    return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#109CF1'}}>{getPercentAndQuantity(total, percent)}</div>
  }
  return <div className={isToday(date) ? 'stock-item-today' : 'stock-item'} style={{backgroundColor: '#885AF8'}}>{getPercentAndQuantity(total, percent)}</div>
}

export const StockLevelByProductTypeTable = ({startDate, endDate, bizLocation}) => {

  if (!(bizLocation && bizLocation.id)) {
    return (
        <Row className="d-flex justify-content-center mt-5">
          <h3>Selecione um local</h3>
        </Row>
    )
  }

  const [endpoint, setEndpoint] = useState(`/ton/v1/stock-histories/product-types/days?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&bizLocationId=${bizLocation.id}`);
  const [gridTemplate, setGridTemplate] = useState(null);

  useEffect(() => {
    let columns = [...DEFAULT_COLUMNS]
    let days = []
    for (let date = startDate.getTime(); date >= endDate.getTime(); date -= ONE_DAY) {
      let title = getTitle(date);
      days.push(
          {
            Header: <div className="header">{title}</div>,
            Cell: row => getRowItem(row.original[title])
          }
      )
    }
    columns.push(...days.reverse())
    setGridTemplate({columns, onData: onGridDateUpdate})
  }, [startDate, endDate]);

  useEffect(() => {
    setEndpoint(`/ton/v1/stock-histories/product-types/days?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&bizLocationId=${bizLocation.id}`)
  }, [startDate, endDate, bizLocation])

  const onGridDateUpdate = (data) => {

    const newContent = [];

    data.content.forEach(x => {
      const item = x;
      x.days.forEach(day => {
        let title = getTitle(day.stockDate);
        const quantity = day.quantity
        const quantitySecure = day.quantitySecure;
        const percent = ((quantity / quantitySecure) * 100).toFixed(2)
        const total = (quantity - quantitySecure);
        item[title] = {};
        item[title].percent = percent;
        item[title].total = total;
        item[title].date = new Date(day.stockDate);
      })
      newContent.push(item);
    });
    data.content = newContent.sort((a, b) => a.productType.reference - b.productType.reference);
  }

  return (
      <div className="stock-level-evolution">
        {!gridTemplate ? <Loading/> : <ByondGrid2 endpoint={endpoint} metadata={gridTemplate}/>}
      </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/StockLevel/StockLevelByProductTypeTable.js